template = require('./state_options.html.slim')

angular.module('wbComponents').directive 'wbStateOptions', ->
  scope:
    noSelectText: '='
  restrict: 'E'
  replace: true
  templateUrl: template
  link: ($scope, $el, $attrs) ->
    $scope.states = [
      {abbr: 'AL', name: 'Alabama', country: 'United States'},
      {abbr: 'AK', name: 'Alaska', country: 'United States'},
      {abbr: 'AZ', name: 'Arkansas', country: 'United States'},
      {abbr: 'AR', name: 'Arizona', country: 'United States'},
      {abbr: 'CA', name: 'California', country: 'United States'},
      {abbr: 'CO', name: 'Colorado', country: 'United States'},
      {abbr: 'CT', name: 'Connecticut', country: 'United States'},
      {abbr: 'DE', name: 'Delaware', country: 'United States'},
      {abbr: 'DC', name: 'District Of Columbia', country: 'United States'},
      {abbr: 'FL', name: 'Florida', country: 'United States'},
      {abbr: 'GA', name: 'Georgia', country: 'United States'},
      {abbr: 'HI', name: 'Hawaii', country: 'United States'},
      {abbr: 'ID', name: 'Idaho', country: 'United States'},
      {abbr: 'IL', name: 'Illinois', country: 'United States'},
      {abbr: 'IN', name: 'Indiana', country: 'United States'},
      {abbr: 'IA', name: 'Iowa', country: 'United States'},
      {abbr: 'KS', name: 'Kansas', country: 'United States'},
      {abbr: 'KY', name: 'Kentucky', country: 'United States'},
      {abbr: 'LA', name: 'Louisiana', country: 'United States'},
      {abbr: 'ME', name: 'Maine', country: 'United States'},
      {abbr: 'MD', name: 'Maryland', country: 'United States'},
      {abbr: 'MA', name: 'Massachusetts', country: 'United States'},
      {abbr: 'MI', name: 'Michigan', country: 'United States'},
      {abbr: 'MN', name: 'Minnesota', country: 'United States'},
      {abbr: 'MS', name: 'Mississippi', country: 'United States'},
      {abbr: 'MO', name: 'Missouri', country: 'United States'},
      {abbr: 'MT', name: 'Montana', country: 'United States'},
      {abbr: 'NE', name: 'Nebraska', country: 'United States'},
      {abbr: 'NV', name: 'Nevada', country: 'United States'},
      {abbr: 'NH', name: 'New Hampshire', country: 'United States'},
      {abbr: 'NJ', name: 'New Jersey', country: 'United States'},
      {abbr: 'NM', name: 'New Mexico', country: 'United States'},
      {abbr: 'NY', name: 'New York', country: 'United States'},
      {abbr: 'NC', name: 'North Carolina', country: 'United States'},
      {abbr: 'ND', name: 'North Dakota', country: 'United States'},
      {abbr: 'OH', name: 'Ohio', country: 'United States'},
      {abbr: 'OK', name: 'Oklahoma', country: 'United States'},
      {abbr: 'OR', name: 'Oregon', country: 'United States'},
      {abbr: 'PA', name: 'Pennsylvania', country: 'United States'},
      {abbr: 'RI', name: 'Rhode Island', country: 'United States'},
      {abbr: 'SC', name: 'South Carolina', country: 'United States'},
      {abbr: 'SD', name: 'South Dakota', country: 'United States'},
      {abbr: 'TN', name: 'Tennessee', country: 'United States'},
      {abbr: 'TX', name: 'Texas', country: 'United States'},
      {abbr: 'UT', name: 'Utah', country: 'United States'},
      {abbr: 'VT', name: 'Vermont', country: 'United States'},
      {abbr: 'VA', name: 'Virginia', country: 'United States'},
      {abbr: 'WA', name: 'Washington', country: 'United States'},
      {abbr: 'WV', name: 'West Virginia', country: 'United States'},
      {abbr: 'WI', name: 'Wisconsin', country: 'United States'},
      {abbr: 'WY', name: 'Wyoming', country: 'United States'},
    ]
